module.exports = __webpack_public_path__ + "img/Group 76.50f3b7c6.png";